import React, { Component } from 'react';
import MilestoneService from "../service/MilestoneService";
import MilestoneList from '../components/milestoneList';
import NavigationBar from '../components/navigationBar';

export default class MilestoneOverviewSite extends Component {

    constructor(props) {
        super(props);
        this.milestoneService = new MilestoneService();
        this.state = {
            milestones: [],
            milestoneName: ""
        }

        this.handleChange = this.handleChange.bind(this);

        this.createMilstone = this.createMilstone.bind(this);
    }

    async getMilestones() {
        let result = await this.milestoneService.getMilestones(this.props.match.params.projectID);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                milestones: result
            })
        }
    }
    handleChange({ target }) {
        this.setState({
            [target.name]: target.value
        });
    }

    async createMilstone(event) {
        event.preventDefault();
        if (this.state.milestoneName === "") {
            alert("Milestone Name cannot be empty!");
            return;
        }

        let result = await this.milestoneService.createMilestones(this.props.match.params.projectID, this.state.milestoneName);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            if (!this.state.NoRedirect) {
                this.hideOverlay()
            }
            this.getMilestones();
        }
    }

    showOverlay() {
        document.getElementById("overlay").style.display = "block";
    }

    hideOverlay() {
        document.getElementById("overlay").style.display = "none";
    }

    componentDidMount() {
        this.getMilestones();
    }

    render() {
        const milestonesList = this.state.milestones;
        if (!milestonesList) return null;

        return (
            <div className="body">
                <div id="overlay">
                    <div id='LoginDiv' className='content'>

                        <button onClick={this.hideOverlay}>Back</button><br />
                        <center><h1>New Milestone</h1></center>
                        <form action="#" onSubmit={(event) => { this.createMilstone(event) }}>
                            <label htmlFor="milestoneName"><b>Milestone Name:</b></label><br />
                            <input type="text" name="milestoneName" value={this.state.milestoneName} onChange={this.handleChange} required /><br />
                            <button type="submit">Create Milestone</button>
                        </form>
                    </div>
                </div>

                <NavigationBar {...this.props} />
                <main>
                    <button onClick={this.showOverlay}>Create New</button>
                    <p>Milestones</p>
                    <MilestoneList milestones={this.state.milestones} projectUUID={this.props.match.params.projectID} />
                </main>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/sites/MilestoneOverviewSite.js